<app-header [isHome]="false" [isScrolled]="true"></app-header>
<ion-content>
  <article>
<!--    <ion-breadcrumbs>-->
<!--      <ion-breadcrumb [routerLink]="['/blog']">Your Property Guide</ion-breadcrumb>-->
<!--      <ion-breadcrumb>{{post?.title}}</ion-breadcrumb>-->
<!--    </ion-breadcrumbs>-->
    <h1>{{post?.title }}
      @if (post?.postType === 'event') {
        <div>
        <small>{{post?.eventDate | date: 'MMMM dd, yyyy'}}</small>
        </div>
      }
    </h1>

    <div class="banner">
      <ion-img [src]="post?.imageUrl" alt="Satel Realty Riyadh"></ion-img>
    </div>
    <div [innerHTML]="post?.sanitizedHtml"></div>

    @if (post?.postType === 'event') {
      <div class="image-gallery">
        @for (img of post?.images; track img.id) {
          <div class="image-thumb">
            <ion-img [src]="img.filepath" alt="Satel Realty Riyadh"></ion-img>
          </div>

        }

      </div>
    }
  </article>

  <app-b2b-section></app-b2b-section>
  <app-footer></app-footer>
</ion-content>
